const LOCAL_PUBLIC_ORIGIN = 'http://localhost:5174';

function getPublicOrigin() {
  const configuredOrigin = import.meta.env.VITE_PUBLIC_MENU_ORIGIN?.trim();
  if (configuredOrigin) return configuredOrigin.replace(/\/$/, '');

  if (typeof window === 'undefined') return '';
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') return LOCAL_PUBLIC_ORIGIN;

  if (window.location.hostname === 'menuadmin.trioga.in') return 'https://menu.trioga.in';

  // The Vite override supports other installations while Trioga's admin
  // hostname resolves to its separate public menu hostname by default.
  return window.location.origin.replace(/^([a-z]+:\/\/)(admin\.)/i, '$1');
}

export function getPublicMenuUrl(tenantSlug, menuSlug) {
  const origin = getPublicOrigin();
  return `${origin}/menu/${encodeURIComponent(tenantSlug)}/${encodeURIComponent(menuSlug)}`;
}
